import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { WkAppConfigService } from '../services/wk-app-config.service';
import { Store } from '@ngrx/store';
import { AppStore } from '../store/states/app.state';
import { SnackbarErrorAction } from '../store/actions/app.custom-actions';

export const wkProcessLoaderGuard: CanActivateFn = () => {
  const wkAppConfigService = inject(WkAppConfigService);
  const store = inject<Store<AppStore>>(Store);
  if (!wkAppConfigService.apsEnabled()) {
    store.dispatch(new SnackbarErrorAction('APP.APS_UNAVAILABLE'));
    return false;
  }
  return true;
};
